export default "__VITE_ASSET__d182d977__"